import type { NewsCategory } from '@/lib/types'
import { NEWS_TYPE } from '@/lib/news-types'
import { getShortsHrefForItem } from '@/lib/shorts-slug'
import { absoluteUrl } from '@/lib/site-seo'

export function getShortsHref(id: number): string {
  return `/shorts/${id}`
}

export function getShortsCanonicalUrl(id: number): string {
  return absoluteUrl(`/shorts/${id}`)
}

export function getNewsHref(news: {
  slug: string
  id: number
  isType?: number | null
  category?: NewsCategory | null
  youtube?: string | null
  video?: string | null
  x?: string | null
}): string {
  if (Number(news.isType) === NEWS_TYPE.SHORT) {
    return getShortsHrefForItem(news)
  }
  return `/${news.category?.slug || 'haber'}/${news.slug}-${news.id}`
}

export function isShortsNews(isType?: number | null): boolean {
  return Number(isType) === NEWS_TYPE.SHORT
}
